(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("mc2", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["mc2"] = factory(require("vue"));
	else
		root["mc2"] = factory(root["Vue"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition